import * as React from 'react'
import { SideDrawer } from '@sales-center/components'
import { ReAssignSalesTeamForm } from '@user/components/SalesTeam/ReAssignSalesTeam/ReAssignSalesTeamForm'
import { ReassignDialogProps } from './typings'
import { ENTITY_TYPES } from '@sales-center/common'

export const ReassignDialog: React.FC<ReassignDialogProps> = (props) => {
  const { open, onClose, onUpdate, lead, showInactiveUsers } = props

  return (
    <SideDrawer title="Reassign" open={open} onClose={onClose}>
      <ReAssignSalesTeamForm
        entityType={ENTITY_TYPES.Lead}
        entityId={lead.id}
        onClose={onClose}
        onUpdate={onUpdate}
        salesTeam={{ ...lead }}
        showInactiveUsers={showInactiveUsers}
      />
    </SideDrawer>
  )
}
ReassignDialog.displayName = 'ReassignDialog'
